import { ExportHistoryTranslations } from "./export-history-pt-br";

export const EXPORT_HISTORY_FR_FR: ExportHistoryTranslations = {
	title: "Fichiers exportés",
	subtitle: "Historique des dernières exportations effectuées",
	noExports: "Aucune exportation trouvée",
	noExportsDescription:
		"Vos rapports exportés seront disponibles ici pendant 7 jours pour télécharger ou renvoyer par e-mail.",
	columns: {
		date: "Date/Heure",
		user: "Utilisateur",
		status: "Statut",
		email: "Email",
		actions: "Actions",
		fileName: "Fichier",
	},
	status: {
		success: "Succès",
		pending: "En cours",
		error: "Erreur",
	},
	actions: {
		download: "Télécharger",
		resend: "Renvoyer",
		viewDetails: "Voir les détails",
		retry: "Réessayer",
	},
	tooltips: {
		processing:
			"Nous traitons votre demande.\nBientôt, le rapport sera disponible pour téléchargement",
		error: "Erreur lors du traitement de votre demande.",
		download: "Télécharger le rapport",
		resend: "Renvoyer le rapport",
	},
	messages: {
		resendSuccess: "Fichier renvoyé avec succès!",
		resendError: "Erreur lors du renvoi du fichier",
		downloadError: "Erreur lors du téléchargement du fichier",
		loading: "Chargement...",
		loadError: "Erreur lors du chargement de l'historique des exportations",
	},
	drawer: {
		title: "Fichiers exportés",
		description:
			"Voici les exportations des 7 derniers jours. Vous pouvez les télécharger ou les renvoyer à l'adresse e-mail enregistrée.",
		close: "Fermer",
	},
	exportButton: {
		export: "Exporter",
		exportEmail: "Exporter par e-mail",
		viewHistory: "Fichiers exportés",
	},
	reportTitle: "Rapport du {{startDate}} au {{endDate}}",
	exportedAt: "Exporté le {{date}} à {{time}}",
	to: "Pour:",
};
